/**
 * Targets whose Signals data is read from another target. Only Signals maps
 * these: every other page keeps using the selected target as it is.
 */
const SIGNALS_TARGET_ALIASES: Record<string, string> = {
  flamurtestnudge: 'schaefer_shop',
};

/** The target every Signals request (get and post) should use for `target`. */
export function signalsTarget<T extends string | null | undefined>(target: T): T | string {
  return (target && SIGNALS_TARGET_ALIASES[target]) || target;
}
